import type { Client } from '../client';
import { CommonApi } from './common';
import { UserApi } from './user';
import { SessionApi } from './session';
import { MessagesApi } from './messages';
import { ContactsApi } from './contacts';
import { MediaApi } from './media';
import { FileApi } from './file';
import { LuckyBoxApi } from './luckyBox';
import { WalletApi } from './wallet';
import { EmojiApi } from './emoji';

export * from './messages';
export * from './media';

export default function ApiService(client: Client) {
  const sessionApi = new SessionApi(client);
  const commonApi = new CommonApi(client);
  return {
    /**
     * @deprecated
     * @see CommonApi
     */
    http: commonApi,
    common: commonApi,
    user: new UserApi(client),
    luckyBox: new LuckyBoxApi(client),
    /**
     * @deprecated
     * @see SessionApi
     */
    chat: sessionApi,
    session: sessionApi,
    messages: new MessagesApi(client),
    contacts: new ContactsApi(client),
    media: new MediaApi(client),
    file: new FileApi(client),
    wallet: new WalletApi(client),
    emoji: new EmojiApi(client),
    [Symbol.dispose](): void {
      this.user[Symbol.dispose]();
    },
  };
}

export type ApiServiceType = ReturnType<typeof ApiService>;
